/* eslint-disable no-unused-expressions */
import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
import {
	handleSectionValueChange,
	handleMultiOptionChange,
} from 'actions/customForm/addOrEdit'
import Button from 'components/theme/Button'
import { IconButton } from '@material-ui/core'
import { Add, Delete } from '@material-ui/icons'

const MultiOptions = ({
	handleSectionValueChange,
	itemID,
	field_options,
	handleMultiOptionChange,
	bool,
}) => {
	const fieldOptionsRef = useRef(null)

	const scrollToBottom = () => {
		fieldOptionsRef?.current?.scrollIntoView({ block: 'end' })
	}

	return (
		<div>
			<div style={{ marginBottom: 13 }}>Field options:</div>
			{/* Each field here should also have a delete button next to it */}
			<div
				style={{
					maxHeight: 300,
					overflowY: 'auto',
					marginBottom: 10,
					paddingTop: 10,
					// paddingBottom: '36.5px',
				}}
			>
				{field_options.map((field_option, idx) => (
					<div
						key={`multi_option_field_options_${idx}`}
						style={{ position: 'relative' }}
					>
						<div style={{ width: bool ? '100%' : 'calc(100% - 48px)' }}>
							<Field
								handleChange={({ property, value, type, id }) =>
									handleMultiOptionChange({
										property,
										value,
										modifyType: 'edit',
										id,
										index: idx,
										bool,
									})
								}
								label={
									bool ? (idx === 0 ? 'Yes' : 'No') : `Field option ${idx + 1}`
								}
								property="field_options"
								statePath={(state) => {
									const statePath =
										state.customForm.addOrEdit.sectionsByID?.[itemID]?.field
											?.field_options?.[idx]

									return statePath
								}}
								placeholder={
									bool
										? idx === 0
											? 'Enter a label for the "yes" answer'
											: 'Enter a label for the "no" answer'
										: 'Enter a field option'
								}
								type="field"
								sectionID={itemID}
							/>
						</div>
						{!bool && (
							<div style={{ position: 'absolute', right: 0, bottom: 23 }}>
								<IconButton
									onClick={() =>
										handleMultiOptionChange({
											id: itemID,
											modifyType: 'remove',
											index: idx,
										})
									}
								>
									<Delete />
								</IconButton>
							</div>
						)}
					</div>
				))}
				<div style={{ marginTop: 36.5 }} ref={fieldOptionsRef} />
			</div>
			{!bool && (
				<div
					style={{
						marginTop: '-60.5px',
						backgroundColor: '#fff',
						height: 51,
						position: 'relative',
						zIndex: 1,
					}}
				>
					<Button
						onClick={() => {
							Promise.resolve(
								handleMultiOptionChange({
									id: itemID,
									modifyType: 'add',
									value: '',
								}),
							).then(() => scrollToBottom())
						}}
					>
						<Add style={{ marginRight: 5 }} />
						Add field
					</Button>
				</div>
			)}
		</div>
	)
}

export default connect(
	(state, { itemID }) => ({
		field_options:
			state.customForm.addOrEdit.sectionsByID?.[itemID]?.field?.field_options ||
			[],
	}),
	(dispatch) =>
		bindActionCreators(
			{ handleSectionValueChange, handleMultiOptionChange },
			dispatch,
		),
)(MultiOptions)
